<template>
  <div style='word-break: keep-all;'>
    <div class='flex flex-col lg:flex-row lg:justify-between gap-y-4 lg:gap-y-0 gap-x-0 lg:gap-x-8 mb-8'>
      <div class='w-full lg:w-1/2 flex flex-col justify-start gap-y-2'>
        <h1 class='text-2xl lg:text-3xl font-bold'>
          {{ session.title }}
          <h2 class='text-lg lg:text-xl font-normal text-gray-600 mb-2'>
            {{ session.subtitle }}
          </h2>
        </h1>
        <div class='flex flex-row gap-x-12'>
          <div class='w-52'>
            <div class='text-base lg:text-lg font-semibold uppercase'>
              {{ sessionScheduledStartDate }}
            </div>
            <div class='text-base'>
              {{ sessionScheduledStartTime }} - {{ sessionScheduledEndTime }}
            </div>
            <div class='text-base uppercase mb-2'>
              {{ sessionLocationString }}
            </div>
          </div>
          <session-details-organizers
            v-for='(organizersByRole, role) in organizersGroupedByRole'
            :key='`organizer-role-${role}`'
            :organizers-by-role='organizersByRole'
            :role='role' />
        </div>
      </div>
      <div class='w-full lg:w-1/2 flex flex-row justify-start lg:justify-end items-start gap-x-2'>
        <button v-if='session.configurations.sessionPdfDownloadUrl'
          class='py-4 px-4 lg:px-6 uppercase bg-gray-700 text-white font-semibold text-xs' 
          @click='downloadPdf'>
          {{session.configurations.sessionPdfDownloadName}}
        </button>
        <button v-if='session.configurations.introVideoUrl'
          class='py-4 px-4 lg:px-6 uppercase bg-gray-700 text-white font-semibold text-xs' 
          @click='openIntroduction'>
          session introduction
        </button>
        <button 
          class='py-4 px-6 lg:px-12 uppercase text-white font-semibold text-xs' 
          :style='eventMainThemeColorBg'
          @click='goToSession'>
          go to session
        </button>
      </div>
    </div>
    <div class='border-b'>
      <session-details-by-topic 
         v-for='(subSession, index) in session.listOfSpeakers'
         :key='`subSession-${index}`'
         class='border-t'
         :subSession='subSession'/>
    </div>
    <el-dialog
      :visible.sync='innerSessionIntroductionVisible'
      custom-class='session-introduction-dialog'
      append-to-body>
      <h1 class='text-xl lg:text-2xl font-semibold'>{{session.title}}</h1>
      <div class='mt-4' style='position:relative; padding-bottom:56.25%; overflow:hidden;'>
        <iframe
          v-if='innerSessionIntroductionVisible'
          width='100%'
          height='100%'
          :src='session.configurations.introVideoUrl'
          frameborder='0'
          allowfullscreen='' 
          allow='autoplay;fullscreen;'
          style='position:absolute;'>    
        </iframe>
      </div>
  </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SessionDetailsOrganizers from '@/components/sessions/SessionDetailsOrganizers.vue'
import SessionDetailsByTopic    from '@/components/sessions/SessionDetailsByTopic.vue'
import DateTimeStringHelpers    from '@/utils/date-time-string-helpers'
import groupBy                  from 'lodash/groupBy' 

export default {
  name: 'SessionDetailsFullKhrsProgram',
  components: {
    SessionDetailsOrganizers,
    SessionDetailsByTopic,
  },
  props: [
    'session',
  ],
  data () {
    return {
      innerSessionIntroductionVisible: false,
    }
  },
  computed: {
    ...mapGetters('events', [
      'eventMainThemeColorBg',
    ]),
    sessionScheduledStartDate () {
      return DateTimeStringHelpers.toDateWithDay(this.session.scheduledStartTime)
    },
    sessionScheduledStartTime () {
      return DateTimeStringHelpers.toTime(this.session.scheduledStartTime)
    },
    sessionScheduledEndTime () {
      return DateTimeStringHelpers.toTime(this.session.scheduledEndTime)
    },
    sessionLocationString () {
      return this.session.locations.map(location => location.split('||')[0]).join(', ')
    },
    organizersGroupedByRole () {
      return (this.hasSessionConfigurationsOrganizers) ? groupBy(this.session.configurations.organizers, 'role') : []
    },
    hasSessionConfigurationsOrganizers () {
      return this.session.configurations.organizers && this.session.configurations.organizers.length > 0
    },
    sessionConfigurationsIntroVideoUrl () {
      return this.session.configurations.introVideoUrl && this.session.configurations.introVideoUrl
    },
  },
  methods: {
    goToSession () {
      this.$emit('go-to-current-session')
    },
    openIntroduction () {
      this.innerSessionIntroductionVisible = true
    },
    downloadPdf () {
      window.open(this.session.configurations.sessionPdfDownloadUrl, '_blank')
    },
  }
}
</script>

<style type='scss'>
  .session-introduction-dialog.el-dialog {
    @apply w-full;
    margin-top: 15vh !important;
  }
  
  .session-introduction-dialog .el-dialog__body {
    @apply px-1 py-2;
  }

  @media (min-width: 1024px) { 
    .session-introduction-dialog.el-dialog {
      width: 70%;
      margin-top: 5vh !important;
    }

    .session-introduction-dialog .el-dialog__body {
      @apply px-2 py-4;
    }
  }
</style>
